<form [formGroup]="codeForm">


  <div class="form-item" *ngIf="!edit">
    <label class="mb-3">How do you want supporters to find your {{type}}?</label>

    <div class="d-lg-flex d-block small-process">
      <div class="single-process-type me-3" (click)="link_only = false" [class.selected]="!link_only"> <!-- (click)="processType = 'flexible'" [class.selected]="processType === 'flexible'"-->
        <div><div class="process-bullet"></div></div>
        <i class="qricon-qr-code-scan"></i>
        <div>
          <h3>QR Code</h3>
          <p>Your supporters can scan the code on their device and connect with your {{type}}.</p>
        </div>
      </div>
      <div class="single-process-type" (click)="link_only = true" [class.selected]="link_only">
        <div>
          <div class="process-bullet"></div>
        </div>
        <i class="qricon-smartphone"></i>
        <div>
          <h3>Shared Link</h3>
          <p>Allow your supporters to reach your {{type}} on websites & social media.</p>
        </div>
      </div>
    </div>

  </div>

  <ng-container *ngIf="!link_only">
    <div class="form-item">
      <label class="mb-3">Do you want to track the geo location of the code?</label>

      <div class="d-flex">
        <div class="single-process-type process-type-sm me-3" (click)="loc_available = true" [class.selected]="loc_available">
          <div>
            <div class="process-bullet"></div>
          </div>
          <div>
            <h4 class="mb-0">Yes</h4>
          </div>
        </div>
        <div class="single-process-type process-type-sm" (click)="loc_available = false" [class.selected]="loc_available === false">
          <div><div class="process-bullet"></div></div>
          <div>
            <div class="d-flex align-items-center">
              <h4 class="mb-0">No</h4>
            </div>
          </div>
        </div>
      </div>

    </div>


    <div class="form-item" *ngIf="loc_available">
      <label class="mb-3">Click on the map to set the location</label>
      <map-pin-selector formControlName="loc"></map-pin-selector>
    </div>
  </ng-container>

</form>

<div *nzModalFooter>
  <button class="btn btn-light-primary btn-sm me-2" (click)="destroyModal()">Cancel</button>
  <button
    type="button"
    (click)="submitForm()"
    id="qrpay_sign_up_submit"
    class="btn btn-sm btn-theme"
  >
    <ng-container *ngIf="(submitting | async) === false">
      <span class="indicator-label">Create</span>
    </ng-container>
    <ng-container *ngIf="submitting | async">
        <span class="indicator-progress" [style.display]="'block'">
          Please wait...
          <span
            class="spinner-border spinner-border-sm align-middle ms-2"
          ></span>
        </span>
    </ng-container>
  </button>
</div>

